// components/FormField.js
import React from "react";
import { motion } from "framer-motion";
import "./FormField.css";
const FormField = ({
  id,
  label,
  placeholder,
  type,
  register,
  validation,
  errors,
  options,
  motionProps,
}) => (
  <motion.div {...motionProps}>
    <div className="form_group">
      <label htmlFor={id}>{label}</label>
      {type === "textarea" ? (
        <textarea
          id={id}
          placeholder={placeholder}
          rows={4}
          className={`form_control ${errors[id] ? "error" : ""}`}
          {...register(id, validation)}
        ></textarea>
      ) : type === "select" ? (
        <select
          id={id}
          {...register(id, validation)}
          className={`form_control ${errors[id] ? "error" : ""}`}
        >
          <option value="">選択してください</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          className={`form_control ${errors[id] ? "error" : ""}`}
          {...register(id, validation)}
        />
      )}
      {errors[id] && <span className="form_error">{errors[id].message}</span>}
    </div>
  </motion.div>
);

export default FormField;
